import React from "react";

function SvgComponent() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="32" fill="none" viewBox="0 0 28 32">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.427.43a3.092 3.092 0 013.146 0L26.43 6.827A3.214 3.214 0 0128 9.6v12.8c0 1.144-.598 2.2-1.57 2.773L15.573 31.57a3.092 3.092 0 01-3.146 0L1.57 25.173A3.214 3.214 0 010 22.4V9.6c0-1.144.598-2.2 1.57-2.773L12.427.43zm2.288 1.512a1.405 1.405 0 00-1.43 0L2.428 8.34a1.46 1.46 0 00-.714 1.26V22.4c0 .52.272 1 .714 1.26l10.857 6.398c.442.26.988.26 1.43 0l10.857-6.398c.442-.26.714-.74.714-1.26V9.6c0-.52-.272-1-.714-1.26L14.715 1.941z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.002 6.736c.96 0 1.737.778 1.737 1.737v9.958a1.737 1.737 0 01-3.473 0V8.473c0-.96.777-1.737 1.736-1.737z"
        clipRule="evenodd"
      ></path>
      <path fill="currentColor" d="M15.74 23.41a1.737 1.737 0 11-3.475 0 1.737 1.737 0 013.474 0z"></path>
    </svg>
  );
}

export default SvgComponent;
